// NotesApp source file : _components/user-settings.component.ts
import { normalizeTagFilterScope } from '../../_util/tag-scope.util';
import { Component, OnInit, AfterViewInit, Renderer2, computed, HostListener, ViewChild } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { ActivatedRoute, RouterModule, Router } from '@angular/router';
import * as platform from 'platform';
import { FormsModule } from '@angular/forms';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map, filter, take } from 'rxjs/operators';

import { ButtonModule } from 'primeng/button';
import { SliderModule } from 'primeng/slider';
import { SelectModule } from 'primeng/select';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { MessageService } from 'primeng/api';
import { targetScopedKey } from '../../_util/data-target';
import { StyleClassModule } from 'primeng/styleclass';
import { Popover } from 'primeng/popover';
import { TabsModule } from 'primeng/tabs';

//import { OLD__UserSettingsService } from '../../_service/OLD_usersettings.service';
import { UserSettingsService, UserSettingsDoc, ApiResponse } from 
    '../../_service/user-settings.service';
import { AlertService } from '../../_service/alert.service';
import { DeviceService, PlatformInfo } from '../../_service/device.service';
import { DeviceManagementApiService, DeviceDoc } from 
    '../../_service/device-management.api.service';
import { DataService } from '../../_service/data.service';
import { AuthService } from '../../_service/auth.service';
import { LayoutService } from '../../_service/layout.service';
import { applySystemZoom } from '../../_util/system-zoom.util';
import { AppConfig } from './app.config';
import { FilterParams, FilterService } from '../../_service/filter.service';

@Component({
  selector: 'user-settings',
  imports: [
    FormsModule,
    CommonModule,
    SliderModule,
    SelectModule,
    ButtonModule,
    ToggleButtonModule,
    AppConfig,
    StyleClassModule,
    Popover,
    TabsModule,
  ],
  templateUrl: './user-settings.component.html',
  styleUrls: ['./user-settings.component.scss'],
})
export class UserSettingsComponent implements OnInit, AfterViewInit {
  @ViewChild('pop') pop?: Popover;

  @HostListener('document:keydown.escape', ['$event'])
  onEsc(_: KeyboardEvent) {
    this.pop?.hide();
  }
  devices: any[] = [];
  loadingDevices: boolean = false;
  isOnline: boolean = navigator.onLine;
  showDevices: boolean = false;
  activeTab = 'account';

  availableHomeViews = ['List', 'Calendar']; // 'Categories', 'Cards' and 'Projects' are obsolete as a default view
  homeView: string = 'List'; // default home view
  clientType: any;
  platform: string = '';
  systemZoomFactor: number = 100;
  editorZoomFactor: number = 100;
  availableThemes: string[] = [];
  selectedTheme: string = '';
  menuItems = Array.from({ length: 1000 }, (_, i) => ({ id: i, name: `Item ${i + 1}` }));
  username$!: Observable<string | null>;
  platformString?: string = '';
  myPlatformInfo?: PlatformInfo;
  clientName: string = '';
  deviceLabel: string = '';
  deviceId: string = '';
  // Account fields
  doc_id: string = '';
  displayName: string = '';
  email: string = '';
  last_modified: string | null = null;
  favoriteNoteIds: string[] = [];
  // Synchronisation method
  syncMethod: string = 'Automatic';
  isDarkMode = computed(() => this.layoutService.appState().darkMode);
  selectedPrimaryColor = computed(() => this.layoutService.appState().primary);
  autosaveEnabled: boolean = true;
  showFavorites: boolean = true;
  showRecent: boolean = true;
  recentDays: number = 5;
  savedSearches: any[] = []; // Array of SavedSearch objects from user settings
  recentDayOptions = [
    { label: '1 day', value: 1 },
    { label: '2 days', value: 2 },
    { label: '3 days', value: 3 },
    { label: '5 days', value: 5 },
    { label: '7 days', value: 7 },
    { label: '14 days', value: 14 },
    { label: '30 days', value: 30 },
  ];

  constructor(
    private auth: AuthService,
    private userSettings: UserSettingsService,
    private deviceApi: DeviceManagementApiService,
    public deviceService: DeviceService,
    private data_service: DataService,
    private filterService: FilterService,
    private route: ActivatedRoute,
    private router: Router,
    //private renderer: Renderer2,
    private alerts: AlertService,
    private location: Location,
    private messages: MessageService,
    private layoutService: LayoutService,
  ) {
    console.log('Name: ', platform.name); // "Chrome" | "Safari" | "Node.js"
    console.log('Version: ', platform.version); // "116.0.0" (browser version)
    console.log('Product: ', platform.product); // "iPhone" | "iPad" | "Pixel"
    console.log('Manufacturer: ', platform.manufacturer); // e.g. "Apple"
    console.log('OS: ', platform.os); // { family: "OS X", version: "10.15.7" }
    console.log('Description: ', platform.description); //Chrome 116 on OS X 10.15.7"
  }

  ngOnInit(): void {
    this.username$ = this.auth.username$;

    // Listen for online/offline events
    window.addEventListener('online', () => {
      this.isOnline = true;
    });
    window.addEventListener('offline', () => {
      this.isOnline = false;
    });
    const theme = localStorage.getItem('selectedTheme');
    const primary = localStorage.getItem('primaryColor');
    const darkMode = localStorage.getItem('darkMode');

    if (theme) {
      this.userSettings.applyTheme(theme);
    }

    if (primary && this.isHexColor(primary)) {
      document.documentElement.style.setProperty('--primary-color', primary);
      document.documentElement.style.setProperty('--p-primary-color', primary);
    }

    if (darkMode === 'true' || darkMode === 'false') {
      this.layoutService.appState.update((state) => ({
        ...state,
        darkMode: darkMode === 'true',
      }));
    }

    // load zooms from service
    this.systemZoomFactor = this.userSettings.getSystemZoomFactor();
    this.editorZoomFactor = this.userSettings.getEditorZoomFactor();
    this.userSettings.editorZoomFactor$.subscribe((value) => {
      this.editorZoomFactor = value;
    });
    console.log('UserSettingsComponent init');
    this.clientType = this.getClientType();
    this.platform = JSON.stringify(this.getPlatformInfo());
    this.availableThemes = this.userSettings.getAvailableThemes();
    this.userSettings.loadSavedTheme();
    this.selectedTheme = localStorage.getItem('selectedTheme') || 
        this.availableThemes[0];
    this.myPlatformInfo = this.deviceService.getPlatformInfo();
    console.log('my Platform : ', this.myPlatformInfo);
    this.platformString = platform.name;
    this.clientName = "'s " + this.platformString + ' (' + 
        this.myPlatformInfo?.model + ')';
    //this.deviceLabel = this.clientName;

    // Load persisted account fields if available
    this.displayName = localStorage.getItem(targetScopedKey('displayName')) || '';
    this.email = localStorage.getItem(targetScopedKey('email')) || '';
    // ensure we have a device id locally
    this.deviceId = this.deviceService.getOrCreateDeviceId();

    const requestedTab = this.route.snapshot.queryParamMap.get('tab');
    if (this.isValidTab(requestedTab)) {
      this.activeTab = requestedTab;
      if (requestedTab === 'saved-searches') {
        this.loadSavedSearches();
      }
    }

    this.route.queryParamMap.subscribe((params) => {
      const tab = params.get('tab');
      if (this.isValidTab(tab) && tab !== this.activeTab) {
        this.activeTab = tab;
        if (tab === 'saved-searches') {
          this.loadSavedSearches();
        }
      }
    });

    // Load server-side settings
    this.loadUserSettingsFromServer();
    // Load device label from Device Management service
    this.loadDeviceFromServer();
  }


  ngAfterViewInit(): void {
  // Safari sometimes fails to recalc scaled width on SPA navigation
  requestAnimationFrame(() => {
    document.body.style.display = 'none';
    void document.body.offsetHeight; // force reflow
    document.body.style.display = '';
  });
}

  toggleDevices(): void {
    this.showDevices = !this.showDevices;
    if (this.showDevices && this.isOnline) {
      this.loadDevices();
    }
  }

  onTabValueChange(value: string | number) {
    if (value === 'devices' && this.isOnline) {
      this.loadDevices();
    } else if (value === 'saved-searches') {
      this.loadSavedSearches();
    }
  }

  private isValidTab(value: string | null): value is 'account' | 'saved-searches' | 'device' | 'devices' {
    return value === 'account' || value === 'saved-searches' || value === 'device' || value === 'devices';
  }

  loadDevices() {
    this.loadingDevices = true;
    this.deviceApi
      .list()
      .pipe(
        catchError((err) => {
          console.warn('Failed to load devices', err);
          return of({ status: 'error' } as ApiResponse<DeviceDoc[]>);
        }),
      )
      .subscribe((resp) => {
        if (resp.status === 'success' && Array.isArray(resp.data)) {
          this.devices = resp.data;
        } else {
          this.devices = [];
        }
        this.loadingDevices = false;
      });
  }


  loadSavedSearches(): void {
    // Load from the current user settings
    this.userSettings.userSettings$.pipe(
      filter((settings) => !!settings),
      take(1),
    ).subscribe((settings) => {
      if (settings && Array.isArray(settings.savedSearches)) {
        this.savedSearches = this.normalizeSavedSearchesForDisplay(settings.savedSearches);
      } else {
        this.savedSearches = [];
      }
    });
  }

  moveSavedSearchUp(index: number): void {
    this.moveSavedSearch(index, index - 1);
  }

  moveSavedSearchDown(index: number): void {
    this.moveSavedSearch(index, index + 1);
  }

  private moveSavedSearch(fromIndex: number, toIndex: number): void {
    if (fromIndex < 0 || fromIndex >= this.savedSearches.length) {
      return;
    }
    if (toIndex < 0 || toIndex >= this.savedSearches.length) {
      return;
    }
    if (fromIndex === toIndex) {
      return;
    }

    const reordered = [...this.savedSearches];
    const [moved] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, moved);
    this.savedSearches = this.resequenceSavedSearches(reordered);
  }

  deleteSavedSearch(index: number): void {
    if (index < 0 || index >= this.savedSearches.length) return;

    const searchName = this.savedSearches[index]?.name || 'Unknown';
    if (!confirm(`Are you sure you want to delete the preset "${searchName}"?`)) {
      return;
    }

    const updatedSearches = this.resequenceSavedSearches(this.savedSearches.filter((_, i) => i !== index));
    this.userSettings.updateSavedSearches(updatedSearches).subscribe(
      (resp) => {
        if (resp.status === 'success') {
          this.savedSearches = this.normalizeSavedSearchesForDisplay(updatedSearches);
          this.alerts.success(`Preset "${searchName}" deleted`);
        } else {
          this.alerts.error('Failed to delete saved search');
        }
      },
      (error) => {
        console.error('Error deleting saved search:', error);
        this.alerts.error('Failed to delete saved search');
      },
    );
  }

  renameSavedSearch(index: number): void {
    if (index < 0 || index >= this.savedSearches.length) {
      return;
    }

    const target = this.savedSearches[index];
    if (!target || typeof target !== 'object') {
      this.alerts.error('Invalid saved search entry');
      return;
    }

    const currentName = (target.name || '').toString();
    const enteredName = prompt('Enter a new name for this preset:', currentName);

    if (enteredName === null) {
      return;
    }

    const trimmedName = enteredName.trim();
    if (!trimmedName) {
      this.alerts.error('Preset name cannot be empty');
      return;
    }

    if (trimmedName === currentName) {
      return;
    }

    const duplicateIndex = this.savedSearches.findIndex(
      (search, i) => i !== index && (search?.name || '').toString().trim().toLowerCase() === trimmedName.toLowerCase(),
    );
    if (duplicateIndex >= 0) {
      this.alerts.error(`A preset named "${trimmedName}" already exists`);
      return;
    }

    const updatedSearches = this.resequenceSavedSearches(this.savedSearches.map((search, i) =>
      i === index
        ? {
            ...search,
            name: trimmedName,
          }
        : search,
    ));

    this.userSettings.updateSavedSearches(updatedSearches).subscribe(
      (resp) => {
        if (resp.status === 'success') {
          this.savedSearches = this.normalizeSavedSearchesForDisplay(updatedSearches);
          this.alerts.success(`Preset renamed to "${trimmedName}"`);
        } else {
          this.alerts.error('Failed to rename saved search');
        }
      },
      (error) => {
        console.error('Error renaming saved search:', error);
        this.alerts.error('Failed to rename saved search');
      },
    );
  }

  activateSavedSearch(index: number): void {
    if (index < 0 || index >= this.savedSearches.length) {
      return;
    }

    const search = this.savedSearches[index];
    if (!search || typeof search !== 'object') {
      this.alerts.error('Invalid saved search entry');
      return;
    }

    const filter: FilterParams = {
      SearchString: search.searchString ?? '',
      SearchType: search.searchType || 'Title, Keywords & Tags',
      TagIds: Array.isArray(search.tagIds) ? [...search.tagIds] : [],
      TagIncludeMode: search.tagIncludeMode === 'OR' ? 'OR' : 'AND',
      ExcludeTagIds: Array.isArray(search.excludeTagIds) ? [...search.excludeTagIds] : [],
      TagScope: normalizeTagFilterScope(search.tagScope),
      Type: search.type ?? '',
      ProjectName: search.projectName ?? '',
      Status: search.status ?? '(All)',
      ModifiedBetween: this.normalizeDateRange(search.modifiedBetween),
      CreatedBetween: this.normalizeDateRange(search.createdBetween),
      DateFilterField: search.dateFilterField === 'created' ? 'created' : 'modified',
      DateFilterMode: search.dateFilterMode === 'date' ? 'date' : 'days',
      DateSinceDays:
        typeof search.dateSinceDays === 'number' && Number.isFinite(search.dateSinceDays) && search.dateSinceDays > 0
          ? Math.floor(search.dateSinceDays)
          : null,
      DateSinceDate: search.dateSinceDate ? new Date(search.dateSinceDate) : null,
    };

    this.filterService.setFilterParams(filter);
    this.alerts.success(`Preset "${search.name || 'Unnamed'}" activated. It will apply on Home.`);
  }

  private normalizeDateRange(
    value?: { start: Date | string | null; end: Date | string | null } | null,
  ): { start: Date | null; end: Date | null } {
    const toDate = (input: Date | string | null | undefined): Date | null => {
      if (!input) {
        return null;
      }
      const date = input instanceof Date ? input : new Date(input);
      return Number.isNaN(date.getTime()) ? null : date;
    };

    return {
      start: toDate(value?.start),
      end: toDate(value?.end),
    };
  }

  private normalizeSavedSearchesForDisplay(value: any[]): any[] {
    const toOrder = (input: unknown): number => {
      const parsed = Number(input);
      return Number.isFinite(parsed) ? parsed : Number.MAX_SAFE_INTEGER;
    };

    const indexed = [...value]
      .filter((item) => !!item && typeof item === 'object')
      .map((item, index) => ({ item, index }));

    indexed.sort((left, right) => {
      const leftOrder = toOrder(left.item?.displayOrder);
      const rightOrder = toOrder(right.item?.displayOrder);

      const leftHasOrder = leftOrder !== Number.MAX_SAFE_INTEGER;
      const rightHasOrder = rightOrder !== Number.MAX_SAFE_INTEGER;

      if (leftHasOrder && rightHasOrder && leftOrder !== rightOrder) {
        return leftOrder - rightOrder;
      }

      if (leftHasOrder !== rightHasOrder) {
        return leftHasOrder ? -1 : 1;
      }

      return left.index - right.index;
    });

    return this.resequenceSavedSearches(
      indexed.map((entry) => entry.item),
    );
  }

  private resequenceSavedSearches(searches: any[]): any[] {
    return searches.map((search, index) => ({
      ...search,
      displayOrder: index + 1,
    }));
  }

  onThemeChange(_event: any) {
    this.userSettings.applyTheme(this.selectedTheme);
  }
  home(): void {
    this.router.navigate(['/home']);
  }

  cancel(): void {
    this.location.back();
  }

  private loadUserSettingsFromServer(): void {
    this.userSettings.get().subscribe({
      //this.userSettings.getUserSettings().subscribe({
      next: (resp) => {
        if (resp.status !== 'success' || !resp.data) {
          this.alerts.error(resp.error?.message || 'Error - user settings not found on server');
          return;
        }

        const data = resp.data as UserSettingsDoc;
        console.log('Loaded user settings from server:', data);

        if (typeof data._id === 'string') this.doc_id = data._id;
        if (typeof data.displayName === 'string') this.displayName = data.displayName;
        if (typeof data.email === 'string') this.email = data.email;
        if (typeof data.syncMethod === 'string') this.syncMethod = data.syncMethod;
        this.favoriteNoteIds = Array.isArray(data.favoriteNoteIds)
          ? data.favoriteNoteIds.filter((id: unknown) => typeof id === 'string')
          : [];
        if (typeof data.autosaveEnabled === 'boolean') {
          this.autosaveEnabled = data.autosaveEnabled;
        }
        if (typeof data.showFavorites === 'boolean') {
          this.showFavorites = data.showFavorites;
        }
        if (typeof data.showRecent === 'boolean') {
          this.showRecent = data.showRecent;
        }
        if (typeof data.recentDays === 'number') {
          this.recentDays = data.recentDays;
        }
        if (Array.isArray(data.savedSearches)) {
          this.savedSearches = this.normalizeSavedSearchesForDisplay(data.savedSearches);
        }
        this.last_modified = data.last_modified ?? null;
      },
      error: (err) => {
        if (err?.status === 404) {
          this.alerts.error('Error - user settings not found on server');
        } else {
          const msg = err?.error?.error?.message || err?.message || 
            'Failed to load settings.';
          this.alerts.error(msg);
        }
      },
    });
  }

  private loadDeviceFromServer(): void {
    if (!this.deviceId) return;
    this.deviceApi.get(this.deviceId).subscribe({
      next: (resp) => {
        if (resp.status === 'success' && resp.data) {
          const d = resp.data as any;
          if (typeof d.label === 'string') this.deviceLabel = d.label;
          this.applyDeviceDisplaySettings(d);
        }
      },
      error: (_err) => {
        // If not found or error, ignore for now; user can set label and saving will create it
      },
    });
  }

  // TO DO: save user settings to IndexDB !!!!
  saveSettings(): void {
    // User settings payload (device label is now handled separately)
    console.log('COLOR: ', this.layoutService.appState().primary);
    const userDoc: UserSettingsDoc = {
      displayName: this.displayName || undefined,
      email: this.email || undefined,
      syncMethod: this.syncMethod || undefined,
      favoriteNoteIds: Array.isArray(this.favoriteNoteIds) ? this.favoriteNoteIds : [],
      autosaveEnabled: this.autosaveEnabled,
      showFavorites: this.showFavorites,
      showRecent: this.showRecent,
      recentDays: this.recentDays,
      savedSearches: this.resequenceSavedSearches(this.savedSearches),
    };

    const userReq$ = this.userSettings.update(userDoc).pipe(
      catchError((err) => {
        const msg = err?.error?.error?.message || err?.message || 
            'Failed to save settings.';
        this.alerts.error(msg);
        // Re-throw to stop forkJoin
        throw err;
      }),
    );
    localStorage.setItem('selectedTheme', this.selectedTheme || '');
    // Device management operation: persist display settings on the device record.
    const trimmed = (this.deviceLabel || '').trim();
    let deviceReq$;
    if (!this.deviceId) {
      this.deviceId = this.deviceService.getOrCreateDeviceId();
    }
    const persistedPrimaryColor = this.getPersistedPrimaryColor();
    const deviceUpdates: any = {
      theme: this.selectedTheme || undefined,
      primaryColor: persistedPrimaryColor,
      systemZoomFactor: this.systemZoomFactor || undefined,
      editorZoomFactor: this.editorZoomFactor || undefined,
      homeView: this.homeView || undefined,
    };
    if (trimmed.length > 0) {
      deviceUpdates.label = trimmed;
    }

    deviceReq$ = this.deviceApi.update(this.deviceId, deviceUpdates).pipe(
      catchError((err) => {
        const msg = err?.error?.error?.message || err?.message || 
            'Failed to update device settings.';
        this.alerts.error(msg);
        throw err;
      }),
    );

    forkJoin([userReq$, deviceReq$]).subscribe({
      next: (_results) => {
        console.log('Settings saved.');
        this.userSettings.setLocal({
          theme: this.selectedTheme || undefined,
          primaryColor: this.layoutService.appState().primary || undefined,
          darkMode: this.layoutService.appState().darkMode,
          systemZoomFactor: this.systemZoomFactor || undefined,
          editorZoomFactor: this.editorZoomFactor || undefined,
          homeView: this.homeView || undefined,
        });
        this.messages.add({
          key: 'global',
          severity: 'success',
          summary: 'Saved',
          detail: 'User settings were successfully saved.',
          life: 6000,
        });
        try {
          localStorage.setItem(targetScopedKey('displayName'), this.displayName || '');
          localStorage.setItem(targetScopedKey('email'), this.email || '');
        } catch {}
        this.location.back();
      },
      error: (_err) => {
        // Errors already surfaced via catchError above
      },
    });
  }

  // BUG - what should happen if user deletes active device record?
  deleteDevice(deviceId: string): void {
    if (!deviceId) {
        const msg = 'Failed to delete device: device ID is required and must not be empty.';
        this.alerts.error(msg);
        return;
    }
    if (deviceId === this.deviceId) {
        const msg = 'Cannot delete the current active device record.';
        this.alerts.error(msg);
        return;
    }

    const ok = confirm(`Delete this device record? This will delete all local 
        data for this device. This cannot be undone.`);
    if (!ok) return;

    this.deviceApi.delete(deviceId).subscribe({
      next: (_resp) => {
        this.alerts.success('Device record deleted.');
        //this.deviceLabel = '';
        this.loadDevices();
      },
      error: (err) => {
        // Treat 404 as success (already deleted)
        if (err?.status === 404) {
          this.alerts.success('Device record deleted.');
          //this.deviceLabel = '';
        } else {
          const msg = err?.error?.error?.message || err?.message || 
            'Failed to delete device.';
          this.alerts.error(msg);
        }
      },
    });
  }

// OBSOLETE!!!
//   async deleteDeviceFromList(deviceId: string) {
//     if (!confirm('Are you sure you want to delete this device?')) return;
//     try {
//       const resp = await fetch(`/api/devices/${deviceId}`, {
//         method: 'DELETE',
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem('access_token')}`,
//           'Content-Type': 'application/json',
//         },
//       });
//       const data = await resp.json();
//       if (data.status === 'success') {
//         this.alerts.success('Device deleted.');
//         this.loadDevices();
//       } else {
//         this.alerts.error(data.error?.message || 'Failed to delete device.');
//       }
//     } catch (err) {
//       this.alerts.error('Error deleting device.');
//     }
//   }

  getClientType(): 'mobile' | 'tablet' | 'desktop' {
    const product = platform.product || '';
    const osFamily = platform.os?.family || '';
    const userAgent = navigator.userAgent || '';

    // Check specifically for iPad by looking at the userAgent string
    const isiPad = /iPad|Macintosh/.test(userAgent) && 'ontouchend' in document;

    if (isiPad) {
      return 'tablet';
    } else if (/Mobile|Android|iPhone|iPod/.test(product)) {
      return 'mobile';
    } else if (/Tablet/.test(product)) {
      return 'tablet';
    } else {
      return 'desktop';
    }
  }

  // Additional platform information methods can be added as needed
  getPlatformInfo() {
    return {
      name: platform.name,
      version: platform.version,
      os: platform.os ? platform.os.family : undefined,
      description: platform.description,
    };
  }

  onZoomFactorChange(type: 'system' | 'editor', event: any): void {
    if (type === 'system') {
      this.userSettings.setSystemZoomFactor(this.systemZoomFactor);
      applySystemZoom(this.systemZoomFactor);
    } else {
      this.userSettings.setEditorZoomFactor(this.editorZoomFactor);
      document.documentElement.style.setProperty('--fontScaleFactor', 
            `${this.editorZoomFactor}%`);
      document.documentElement.style.setProperty('--fontScaleRatio', `${this.editorZoomFactor / 100}`);
    }
  }

  toggleDarkMode() {
    const nextDarkMode = !this.layoutService.appState().darkMode;
    this.userSettings.setLocal({ darkMode: nextDarkMode });
  }

  private isHexColor(value: string): boolean {
    return /^#?[0-9a-fA-F]{6}$/.test(value);
  }

  private getPersistedPrimaryColor(): string | undefined {
    const raw = localStorage.getItem('primaryColor');
    if (!raw) {
      return undefined;
    }

    const trimmed = raw.trim();
    if (!this.isHexColor(trimmed)) {
      return undefined;
    }

    return trimmed.startsWith('#') ? trimmed : `#${trimmed}`;
  }

  get syncMethodDescription(): string {
    if (this.syncMethod === 'Automatic') {
      return 'Changes made locally or remotely will be synchronised automatically';
    } else {
      return `Changes made locally or remotely will not be synchronised
        until you click "Synchronise Now".`;
    }
  }

  private applyDeviceDisplaySettings(device: {
    theme?: string;
    primaryColor?: string;
    darkMode?: boolean;
    systemZoomFactor?: number;
    editorZoomFactor?: number;
    homeView?: string;
  }) {
    if (typeof device.theme === 'string') {
      this.selectedTheme = device.theme;
    }
    if (typeof device.systemZoomFactor === 'number') {
      this.systemZoomFactor = device.systemZoomFactor;
    }
    if (typeof device.editorZoomFactor === 'number') {
      this.editorZoomFactor = device.editorZoomFactor;
    }
    if (typeof device.homeView === 'string') {
      this.homeView = device.homeView;
    }

    this.userSettings.setLocal({
      theme: device.theme,
      primaryColor: device.primaryColor,
      darkMode: device.darkMode,
      systemZoomFactor: device.systemZoomFactor,
      editorZoomFactor: device.editorZoomFactor,
      homeView: device.homeView,
    });
  }
}
